export default __webpack_public_path__ + "static/img6-7a349d957f68ba71f3435eb753fc38a6.jpg";